<template>
  <div>
    <v-card height="100%">
      <v-card-title>
        Management
        <v-spacer></v-spacer>
        <v-btn color="secondary" x-small @click="openEditDetails=true;"><v-icon small>edit</v-icon></v-btn>
      </v-card-title>

      <!-----------------------< LOADERS START >----------------------->
      <v-card-text v-if="currentTicketLoading||ticketUpdateLoading">
        <v-row>
          <v-col cols="12" md="2">
            <v-skeleton-loader type="paragraph"></v-skeleton-loader>
          </v-col>
          <v-col cols="12" md="10">
            <v-row>
              <v-col cols="12" md="6" class="pt-0">
                <v-row>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                  <v-col cols="12" md="4" class="pt-0"><v-skeleton-loader type="paragraph"></v-skeleton-loader></v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6" class="pt-0">
                <v-skeleton-loader type="paragraph"></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!----------------------< LOADERS END >----------------------->

      <v-card-text v-else>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-row>
                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Agent</p>
                    <p><b>{{currentTicket.agent | customPlaceholder}}</b></p>
                  </v-col>

                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Callback Number</p>
                    <p><b>{{currentTicket.callback_number | customPlaceholder}}</b></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Escalation Agent</p>
                    <p><b>{{currentTicket.escalation_agent | customPlaceholder}}</b></p>
                  </v-col>
                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Next Follow Up</p>
                    <p><b>{{currentTicket.next_follow_up_date | formatDate}}</b></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Team</p>
                    <p><b>{{currentTicket.team | customPlaceholder}}</b></p>
                  </v-col>

                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Supplier Ticket ID</p>
                    <p><b>{{currentTicket.supplier_ticket_id | customPlaceholder}}</b></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Cause</p>
                    <p><b>{{ getTicketCause(currentTicket.cause) | customPlaceholder }}</b></p>
                  </v-col>

                  <v-col cols="12" md="6" class="pt-0">
                    <p class="mb-1 text-caption">Cause Summary</p>
                    <p><b>{{ currentTicket.cause_summary | customPlaceholder }}</b></p>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" md="6" offset-md="6" class="pt-0">
                    <p class="mb-1 text-caption">Root cause analysis</p>
                    <p><b>{{ currentTicket.root_cause_analysis | customPlaceholder }}</b></p>
                  </v-col>

                  <v-col cols="12" md="6" offset-md="6" class="pt-0">
                    <p class="mb-1 text-caption">Outcome</p>
                    <p><b>{{ currentTicket.outcome | customPlaceholder }}</b></p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <TicketDetailsDialog v-model="openEditDetails" />
  </div>
</template>

<script>
import TicketDetailsDialog from '@/components/Tickets/Dialogs/TicketDetailsDialog';

import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  components: {TicketDetailsDialog},

  data() {
    return {
      openEditDetails: false,
    }
  },

  computed: {
    ...mapState('tickets',['currentTicket','currentTicketLoading','ticketUpdateLoading']),
    ...mapGetters('tickets', ['getTicketCause']),
  },

  methods: {
    ...mapActions('tickets',['updateTicketData']),

    nl2br(str, is_xhtml) {
      if(typeof str === 'undefined' || str === null){ return ''; }
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
  },
};
</script>

<style lang="scss" scoped></style>
